import { render, staticRenderFns } from "./Datadown.vue?vue&type=template&id=c776f11c&scoped=true&"
import script from "./Datadown.vue?vue&type=script&lang=js&"
export * from "./Datadown.vue?vue&type=script&lang=js&"
import style0 from "./Datadown.vue?vue&type=style&index=0&id=c776f11c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c776f11c",
  null
  
)

export default component.exports